import * as React from 'react';

import { Modal } from '@process-advisor/process-miner/modals/save/modal';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { saveModel } from '@process-advisor/process-miner/api/methods/shared/saveModel';

export const SaveModal = ({AppVersion}) => {
    
    const [isOpen, setIsOpen] = React.useState(false);

    useApiListener(
        Event.saveModal,
        ({ status }) => {
            console.log(apiProvider.getSaveModel())
            if (apiProvider.getSaveModel() === true) {
                setIsOpen(true)
            } else {
                apiProvider.closeProcessMiner({})        
            }
        }
    );
    
    const onSave = async () => {
        await saveModel(AppVersion)
        setIsOpen(false)
        apiProvider.closeProcessMiner({})
    };

    const onNo = () => {
        setIsOpen(false)
        apiProvider.closeProcessMiner({})
    };

    return (
        <Modal open={isOpen} onCancel={() => setIsOpen(false)} onSave={() => onSave()} onNo={() => onNo()} />
    );
};


